import React from 'react';

import { Country } from '../../config';
import { useLanguage } from '../../hooks/useLanguage';

const PaymentLogos = () => {
  const { country } = useLanguage();

  return (
    <div className="payments_shipping-logos">
      {country === Country.EE && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-visa.svg"
            className="payments_shipping-logo payments_shipping-logo--visa"
            alt="visa"
          />
          <img
            src="/icons/shipping-payment-logos/icon-mastercard.svg"
            className="payments_shipping-logo payments_shipping-logo--mastercard"
            alt="mastercard"
          />
          <img src="/icons/shipping-payment-logos/icon-seb.svg" className="payments_shipping-logo payments_shipping-logo--seb" alt="seb" />
          <img src="/icons/shipping-payment-logos/icon-lhv.svg" className="payments_shipping-logo payments_shipping-logo--lhv" alt="lhv" />
          <img
            src="/icons/shipping-payment-logos/icon-swedbank.svg"
            className="payments_shipping-logo payments_shipping-logo--swedbank"
            alt="swedbank"
          />
        </>
      )}
      {country === Country.LV && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-visa.svg"
            className="payments_shipping-logo payments_shipping-logo--visa"
            alt="visa"
          />
          <img
            src="/icons/shipping-payment-logos/icon-mastercard.svg"
            className="payments_shipping-logo payments_shipping-logo--mastercard"
            alt="mastercard"
          />
          <img src="/icons/shipping-payment-logos/icon-seb.svg" className="payments_shipping-logo payments_shipping-logo--seb" alt="seb" />
          <img
            src="/icons/shipping-payment-logos/icon-swedbank.svg"
            className="payments_shipping-logo payments_shipping-logo--swedbank"
            alt="swedbank"
          />
        </>
      )}
      {country === Country.ZA && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-ozow-bw2.svg"
            className="payments_shipping-logo payments_shipping-logo--ozow"
            alt="ozow"
          />
          <img
            src="/icons/shipping-payment-logos/icon-visa.svg"
            className="payments_shipping-logo payments_shipping-logo--visa"
            alt="visa"
          />
          <img
            src="/icons/shipping-payment-logos/icon-mastercard.svg"
            className="payments_shipping-logo payments_shipping-logo--mastercard"
            alt="mastercard"
          />
          <img src="/icons/shipping-payment-logos/icon-eft.svg" className="payments_shipping-logo payments_shipping-logo--eft" alt="EFT" />
        </>
      )}
      {country === Country.KE && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-visa.svg"
            className="payments_shipping-logo payments_shipping-logo--visa"
            alt="visa"
          />
          <img
            src="/icons/shipping-payment-logos/icon-mastercard.svg"
            className="payments_shipping-logo payments_shipping-logo--mastercard"
            alt="mastercard"
          />
          <img
            src="/icons/shipping-payment-logos/icon-mpesa.svg"
            className="payments_shipping-logo payments_shipping-logo--mpesa"
            alt="mpesa"
          />
        </>
      )}
    </div>
  );
};

export default PaymentLogos;
